<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 23.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start p-5 pb-0">
        <h1 class="text-blue mt-3">{{ $t('acccionesprevencion.acciones') }}</h1>
        <p>{{ $t('acccionesprevencion.recuerdo') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">
      <div class="row g-0 p-0 m-0">
        <h2 class="px-0 px-lg-5 m-0 m-lg-5 mt-5 mt-lg-0">{{ $t('acccionesprevencion.analisis') }}</h2>

          <div class="col-12 col-lg-6 text-center text-lg-start mb-5">
            <p class="text-black">{{ $t('acccionesprevencion.junto') }}</p>
          </div>
          <div class="col-12 col-lg-6 px-0">
            <img :src="`${publicPath}img/Grupo de desplazamiento3.jpg`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
          </div>
        </div>

    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau">
        <div class="row">
          <div class="col-12 col-lg-6 p-5 pb-0 text-start">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive mb-3">
            <h6 class="myriadPro"><strong>{{ $t('acccionesprevencion.labor') }}</strong></h6>
            <p class="textSmall text-black" v-html="$t('acccionesprevencion.anna')"></p>
            <div class="row">
              <a href="https://youtu.be/2haoLAa4KQ8" target="_blank" class="btnPlus"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-0 m-0">
            <a href="https://youtu.be/2haoLAa4KQ8" target="_blank"><img :src="`${publicPath}img/Grupo-de-desplazamiento-24.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive"></a>
          </div>
        </div>
      </div>
    </section>

    <section class="p-0 px-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 mt-5 mt-lg-0">
        <h2>{{ $t('acccionesprevencion.contenidos') }}</h2>
        <h6 class="text-black my-3 px-0 px-lg-5 mx-0 mx-lg-5"><strong>{{ $t('acccionesprevencion.mantenido')}}</strong></h6>
        <div class="row">
          <a :href="`${link1}`" class="btnPlus p-3" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></a>
        </div>
        <div class="container border border-light p-3 m-0">
          <div class=" row justify-content-start align-items-end g-0">
            <div class="col-3 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF1A.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive sombra">
            </div>
            <div class="col-3 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF1B.jpg`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive sombra">
            </div>
            <div class="col-3 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF1C.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive sombra">
            </div>
          </div>
          <div class=" row justify-content-end g-0">
            <div class="col-2 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF2A.jpg`" data-aos="fade-right" data-aos-delay="300" data-aos-duration="1000" class="img-responsive sombra">
            </div>
            <div class="col-2 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF2B.jpg`" data-aos="fade-right" data-aos-delay="400" data-aos-duration="1000" class="img-responsive sombra">
            </div>
            <div class="col-3 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF2C.jpg`" data-aos="fade-right" data-aos-delay="500" data-aos-duration="1000" class="img-responsive sombra">
            </div>
            <div class="col-3 m-0 m-lg-2">
              <img :src="`${publicPath}img/preF2D.jpg`" data-aos="fade-right" data-aos-delay="600" data-aos-duration="1000" class="img-responsive sombra">
            </div>
          </div>
        </div>
        <hr class="filigrana">

      </div>
    </section>

    <section class="p-0 px-lg-5 py-lg-0 mx-0 mx-lg-5">
      <div class="row">
        <h2 class="mb-3">{{ $t('acccionesprevencion.nuevo_modelo') }}</h2>
        <div class="col-12 col-lg-6 text-center text-lg-start pe-3 pe-lg-5">
          <p class="text-black" v-html="$t('acccionesprevencion.principales_herra')"></p>
          <div class="row text-center">
             <a :href="`${link2}`" class="btnPlus p-3" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></a>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="container border border-light p-3 m-0">
            <div class="row align-items-top pt-2 align-items-end">
              <div class="col-12 col-lg-4 p-0 pt-5">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_jornadas'
                    :startAmount='0'
                    :endAmount='136'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall text-black">{{ $t('acccionesprevencion.jornadas') }}</p>
              </div>
              <div class="col-12 col-lg-4 p-0">
                <img :src="`${publicPath}img/Grupo 1878.png`" data-aos="fade-down" data-aos-duration="1000" data-aos-id="start-counter" class="img-responsive">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_distintas'
                    :startAmount='0'
                    :endAmount='36'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall text-black">{{ $t('acccionesprevencion.distintas') }}<br><br></p>
              </div>
              <div class="col-12 col-lg-4 p-0 pt-5">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_participantes'
                    :startAmount='0'
                    :endAmount='2513'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall text-black">{{ $t('acccionesprevencion.participantes') }}<br><br></p>
              </div>
            </div>
          </div>
          <hr class="filigrana mb-5 mb-lg-0">
        </div>

      </div>
    </section>


    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau p-3 m-0 mt-5 mt-lg-0 px-lg-5 py-lg-5">
        <h5 class="mb-4">{{ $t('literals.contribucion_a_los_ods') }}</h5>
        <div class="row justify-content-center">
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS03.png`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS08.png`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS09.png`" data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS10.png`" data-aos="fade-left" data-aos-delay="400" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS17.png`" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" class="img-responsive">
          </div>
        </div>
      </div>
    </section>


    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/asistencia-sanitaria-personalizada"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.asistencia-sanitaria-personalizada") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/tecnologia-al-servicio-de-las-personas">{{ $t("nav.tecnologia-al-servicio-de-las-personas") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>
</template>


<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ',',
      link1: 'https://www.mutuauniversal.net/es/servicios/gestion-de-la-prevencion/riesgos-biologicos/coronavirus-2019/',
      link2:  'https://www.mutuauniversal.net/es/actualidad/jornadas-y-actos/',
      locale:this.$i18n.locale
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter', this.startCounter);
    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }

    if(this.$i18n.locale=="ca"){
      this.link1 = 'https://www.mutuauniversal.net/ca/servicios/gestion-de-la-prevencion/riesgos-biologicos/coronavirus-2019/index.html';
      this.link2 = 'https://www.mutuauniversal.net/ca/actualidad/jornadas-y-actos/index.html';
    }

    if(this.$i18n.locale=="en"){
      this.link1 = 'https://www.mutuauniversal.net/en/servicios/gestion-de-la-prevencion/riesgos-biologicos/coronavirus-2019/index.html';
      this.link2 = 'https://www.mutuauniversal.net/en/actualidad/jornadas-y-actos/index.html';
    }

    if(this.$i18n.locale=="ga"){
      this.link1 = 'https://www.mutuauniversal.net/gl/servicios/gestion-de-la-prevencion/riesgos-biologicos/coronavirus-2019/index.html';
      this.link2 = 'https://www.mutuauniversal.net/gl/actualidad/jornadas-y-actos/index.html';
    }

    if(this.$i18n.locale=="eu"){
      this.link1 = 'https://www.mutuauniversal.net/eu/servicios/gestion-de-la-prevencion/riesgos-biologicos/coronavirus-2019/index.html';
      this.link2 = 'https://www.mutuauniversal.net/eu/actualidad/jornadas-y-actos/index.html';
    }

  },
  methods: {
    startCounter() {
      if (this.$refs.counter_jornadas != null) {
        this.$refs.counter_jornadas.start();
      }
      if (this.$refs.counter_distintas != null) {
        this.$refs.counter_distintas.start();
      }
      if (this.$refs.counter_participantes != null) {
        this.$refs.counter_participantes.start();
      }
    }
  }
}
</script>


